import { useState, useEffect, useCallback } from 'react';
import { producaoService } from '../../services';
import { authService } from '../../services';
import './KDS.css';

function agruparPorPedido(itens) {
  const map = {};
  for (const item of itens) {
    if (!map[item.pedido_id]) {
      map[item.pedido_id] = {
        pedido_id: item.pedido_id,
        numero: item.pedido_numero,
        tipo: item.pedido_tipo,
        max_espera: 0,
        itens: [],
      };
    }
    map[item.pedido_id].itens.push(item);
    if ((item.minutos_espera || 0) > map[item.pedido_id].max_espera) {
      map[item.pedido_id].max_espera = item.minutos_espera || 0;
    }
  }
  return Object.values(map).sort((a, b) => b.max_espera - a.max_espera);
}

export default function KDS() {
  const [logado, setLogado] = useState(!!localStorage.getItem('token'));
  const [loginForm, setLoginForm] = useState({ username: '', password: '' });
  const [loginErro, setLoginErro] = useState('');
  const [pedidos, setPedidos] = useState([]);
  const [ultimaAtt, setUltimaAtt] = useState('');

  const carregarProducao = useCallback(async () => {
    try {
      const { data } = await producaoService.listar({});
      const ativos = data.filter(i => i.status === 'fila' || i.status === 'preparando');
      setPedidos(agruparPorPedido(ativos));
      setUltimaAtt(new Date().toLocaleTimeString('pt-BR'));
    } catch {}
  }, []);

  useEffect(() => {
    if (!logado) return;
    carregarProducao();
    const interval = setInterval(carregarProducao, 15000);
    return () => clearInterval(interval);
  }, [logado, carregarProducao]);

  const atualizarStatus = async (id, novoStatus) => {
    try {
      await producaoService.atualizarStatus(id, novoStatus);
      carregarProducao();
    } catch {}
  };

  const fazerLogin = async (e) => {
    e.preventDefault();
    setLoginErro('');
    try {
      const { data } = await authService.login(loginForm.username, loginForm.password);
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      setLogado(true);
    } catch (err) {
      setLoginErro(err.response?.data?.error || 'Usuário ou senha inválidos');
    }
  };

  /* ─── Login ─── */
  if (!logado) {
    return (
      <div className="kds-login">
        <div className="kds-login-card">
          <div className="kds-login-icone">🍳</div>
          <h1>Monitor de Cozinha</h1>
          <form onSubmit={fazerLogin}>
            {loginErro && <div className="kds-erro">{loginErro}</div>}
            <input
              type="text"
              placeholder="Usuário"
              value={loginForm.username}
              onChange={e => setLoginForm({ ...loginForm, username: e.target.value })}
              required
            />
            <input
              type="password"
              placeholder="Senha"
              value={loginForm.password}
              onChange={e => setLoginForm({ ...loginForm, password: e.target.value })}
              required
            />
            <button type="submit">Entrar</button>
          </form>
        </div>
      </div>
    );
  }

  const urgente = m => m >= 15;
  const atencao = m => m >= 8 && m < 15;

  return (
    <div className="kds-page">
      <div className="kds-header">
        <h1>🍳 Cozinha</h1>
        <div className="kds-header-info">
          <span className={`kds-total-badge ${pedidos.length > 0 ? 'ativo' : ''}`}>
            {pedidos.length} pedido{pedidos.length !== 1 ? 's' : ''}
          </span>
          {ultimaAtt && <span className="kds-att">↻ {ultimaAtt}</span>}
        </div>
        <button className="kds-refresh-btn" onClick={carregarProducao}>Atualizar</button>
      </div>

      {pedidos.length === 0 ? (
        <div className="kds-vazio">
          <div className="kds-vazio-icone">✅</div>
          <p>Tudo em dia! Nenhum pedido na fila.</p>
        </div>
      ) : (
        <div className="kds-grid">
          {pedidos.map(pedido => (
            <div
              key={pedido.pedido_id}
              className={`kds-card ${urgente(pedido.max_espera) ? 'urgente' : atencao(pedido.max_espera) ? 'atencao' : ''}`}
            >
              <div className="kds-card-header">
                <div className="kds-pedido-num">#{pedido.numero}</div>
                <div className="kds-pedido-tipo">{pedido.tipo}</div>
                <div className={`kds-tempo ${urgente(pedido.max_espera) ? 'urgente' : atencao(pedido.max_espera) ? 'atencao' : ''}`}>
                  {pedido.max_espera} min
                </div>
              </div>

              <div className="kds-itens">
                {pedido.itens.map(item => (
                  <div key={item.id} className={`kds-item kds-item-${item.status}`}>
                    <div className="kds-item-desc">
                      <span className="kds-item-qty">{item.quantidade}×</span>
                      <span className="kds-item-emoji">{item.emoji || '🥟'}</span>
                      <span className="kds-item-nome">{item.produto_nome}</span>
                      {item.observacao && (
                        <span className="kds-item-obs">⚠ {item.observacao}</span>
                      )}
                    </div>
                    <div className="kds-item-acoes">
                      {item.status === 'fila' && (
                        <button
                          className="kds-btn kds-btn-iniciar"
                          onClick={() => atualizarStatus(item.id, 'preparando')}
                        >
                          🔥 Iniciar
                        </button>
                      )}
                      {item.status === 'preparando' && (
                        <button
                          className="kds-btn kds-btn-pronto"
                          onClick={() => atualizarStatus(item.id, 'pronto')}
                        >
                          ✅ Pronto
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
